/**
 * One note of the annex.
 *
 * Everything this kind is: how it is made, how it is read back, what it looks
 * like on the page, and how it is edited. Nothing outside this folder needs to
 * know the kind exists.
 */

import { readString } from '@/domain/json'
import { type NoteSection } from '@/domain/section'
import NoteBlock from '@/sections/note/NoteBlock.vue'
import NoteInspector from '@/sections/note/NoteInspector.vue'
import type { SectionDefinition } from '@/sections/types'

export const noteSection: SectionDefinition<'note', NoteSection> = {
  kind: 'note',
  band: 'annex',

  icon: ['M3 3.5h2.5', 'M4.2 3.5v3.5', 'M8 4.5h5.5', 'M3 10h10.5', 'M3 13h7'],

  create: (id, title) => ({
    id,
    kind: 'note',
    title,
    number: '',
    html: '',
  }),

  read: ({ id, title, stored }) => ({
    id,
    kind: 'note',
    title,
    number: readString(stored, 'number'),
    html: readString(stored, 'html'),
  }),

  block: NoteBlock,
  inspector: NoteInspector,
}
